import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
    statusCode: number;
    message?: string;
    data?: any;
};

export const dashboardApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboardData: builder.query<
            CommonResponse,
            { serviceId?: string | null } | void
        >({
            query: (params) => {
                let url = END_POINTS.dashboardtables;
                if (params && params.serviceId && params.serviceId !== "default" && params.serviceId !== "all") {
                    url += `?serviceId=${params.serviceId}`;
                }
                return {
                    url,
                    method: "GET",
                    headers: {
                        "x-portal": "service_provider",
                        "store": "1",
                    },
                };
            },
        }),
        getDashboardAnalytics: builder.query<
            CommonResponse,
            { serviceId?: string | null; timePeriod?: string }
        >({
            query: (params) => {
                let qs = "";
                if (params.serviceId && params.serviceId !== "default" && params.serviceId !== "all") qs += `serviceId=${params.serviceId}&`;
                if (params.timePeriod) qs += `timePeriod=${params.timePeriod}&`;
                return {
                    url: `${END_POINTS.dashboardAnalytics}?${qs}`,
                    method: "GET",
                    headers: {
                        "x-portal": "service_provider",
                        "store": "1",
                    },
                };
            },
        }),
        getDashboardGraphs: builder.query<
            CommonResponse,
            { type: string; period: string; serviceId?: string | null }
        >({
            query: ({ type, period, serviceId }) => {
                let url = `${END_POINTS.dashboardGraphs}?type=${type}&period=${period}`;
                if (serviceId && serviceId !== "default" && serviceId !== "all") {
                    url += `&serviceId=${serviceId}`;
                }
                return {
                    url,
                    method: "GET",
                    headers: {
                        "x-portal": "service_provider",
                        "store": "1",
                    },
                };
            },
        }),
    }),
});

export const {
    useGetDashboardDataQuery,
    useLazyGetDashboardDataQuery,
    useGetDashboardAnalyticsQuery,
    useLazyGetDashboardAnalyticsQuery,
    useGetDashboardGraphsQuery,
    useLazyGetDashboardGraphsQuery,
} = dashboardApi;
